// Line chart
const figure_1_3 = {
  type: "stacked",
  figureNumber: "1.3",
  title: "Persistent Scarring",
  subTitle: "(percent deviation from January 2020 *World Economic Outlook* forecasted level)",
  caption: "Employment and economic activity in emerging markets and low-income developing countries is unlikely to recover in the medium term.",
  source: "Sources: IMF, *World Economic Outlook*; and IMF staff calculations. /n LIDCs = Low-Income Developing Countries.",
  data: {
    labels: ["2019", "2020", "2021", "2022", "2023", "2024", "2025", "2026"],
    datasets: [
      {
        label: "Advanced (Jan 2022)",
        fill: false,
        borderColor: "#508C34",
        backgroundColor: "#FFFFFF",
        tension: 0.1,
        data: [0.0, -6.05, -2.89, -0.63, 0.36, 0.57, 0.67, 0.72],
        borderDash: [5, 5],
      },
      {
        label: "Advanced (Apr 2022)",
        fill: false,
        borderColor: "#508C34",
        backgroundColor: "#508C34",
        tension: 0.1,
        data: [0.0, -6.03, -2.73, -1.08, -0.29, -0.15, -0.01, 0.06],
      },
      {
        label: "Emerging (Jan 2022)",
        fill: false,
        borderColor: "#DA322A",
        backgroundColor: "#FFFFFF",
        tension: 0.1,
        data: [0.0, -6.09, -4.32, -4.14, -4.2, -4.33, -4.5, -4.76],
        borderDash: [5, 5],
      },
      {
        label: "Emerging (Apr 2022)",
        fill: false,
        borderColor: "#DA322A",
        backgroundColor: "#DA322A",
        tension: 0.1,
        data: [0.0, -6.06, -4.04, -4.79, -5.12, -5.24, -5.44, -5.72],
      },
      {
        label: "LIDCs (Jan 2022)",
        fill: false,
        borderColor: "#F1AF2A",
        backgroundColor: "#FFFFFF",
        tension: 0.1,
        data: [0.0, -4.72, -6.57, -6.66, -6.63, -6.57, -6.54, -6.54],
        borderDash: [5, 5],
      },
      {
        label: "LIDCs (Apr 2022)",
        fill: false,
        borderColor: "#F1AF2A",
        backgroundColor: "#F1AF2A",
        tension: 0.1,
        data: [0.0, -4.69, -5.76, -6.44, -6.54, -6.48, -6.43, -6.44],
      },
    ],
  },
  options: {
    maintainAspectRatio: false,
    responsive: true,
    aspectRatio: 0.7,
    height: "large",
    legend: {
      position: "top",
      labels: {
        boxWidth: 8,
        padding: 15,
        usePointStyle: true,
      },
      align: "start",
    },
    elements: {
      point: {
        radius: 3,
      },
    },
    tooltips: {
      callbacks: {
        title: function (tooltipItem, data) {
          let label = tooltipItem[0].label.replace(/,/g, " ")
          return label
        },
      },
    },
  },
}

export default figure_1_3
